import { useEffect, useState } from "react";
import API from "../../../../services/api";

const useReviews = () => {
  const [reviews, setReviews] = useState([]);

  const [stats, setStats] = useState({
    totalReviews: 0,
    averageRating: 0,
    pendingReplies: 0,
    ratingDistribution: {
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0,
    },
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ============================
  // Fetch Provider Reviews
  // ============================
  const fetchReviews = async () => {
    try {
      const { data } = await API.get("/reviews/provider");

      setReviews(data.reviews || []);
      setError("");
    } catch (err) {
      console.error("Fetch Reviews Error:", err);

      setReviews([]);

      setError(
        err.response?.data?.message ||
          "Failed to load reviews"
      );
    }
  };

  // ============================
  // Fetch Review Statistics
  // ============================
  const fetchStats = async () => {
    try {
      const { data } = await API.get(
        "/reviews/provider/stats"
      );

      setStats({
        totalReviews: data.totalReviews || 0,
        averageRating: data.averageRating || 0,
        pendingReplies: data.pendingReplies || 0,
        ratingDistribution:
          data.ratingDistribution || {
            5: 0,
            4: 0,
            3: 0,
            2: 0,
            1: 0,
          },
      });
    } catch (err) {
      console.error("Fetch Stats Error:", err);
    }
  };

  // ============================
  // Reply To Review
  // ============================
  const replyToReview = async (
    reviewId,
    message
  ) => {
    try {
      await API.put(
        `/reviews/${reviewId}/reply`,
        {
          message,
        }
      );

      await refresh();

      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  // ============================
  // Update Reply
  // ============================
  const updateReply = async (
    reviewId,
    message
  ) => {
    try {
      await API.put(
        `/reviews/${reviewId}/reply/update`,
        {
          message,
        }
      );

      await refresh();

      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  // ============================
  // Delete Reply
  // ============================
  const deleteReply = async (
    reviewId
  ) => {
    try {
      await API.delete(
        `/reviews/${reviewId}/reply`
      );

      await refresh();

      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  // ============================
  // Refresh Data
  // ============================
  const refresh = async () => {
    try {
      setLoading(true);

      await Promise.all([
        fetchReviews(),
        fetchStats(),
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return {
    reviews,
    stats,
    loading,
    error,
    refresh,
    replyToReview,
    updateReply,
    deleteReply,
  };
};

export default useReviews;